import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CTABand } from "@/components/site/CTABand";
import { services } from "@/data/content";
import { Check, ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <div>
      <PageHero
        overline="Our Services"
        title={["Everything your", "buildings need,", "under one roof."]}
        subtitle="Seven core services, fully integrated and managed by a single accountable partner — scalable from one site to a national portfolio."
        image={services[0].image}
      />

      <section className="bg-ink py-16 md:py-24 border-t border-border">
        <div className="max-w-container mx-auto px-6 md:px-12 space-y-4 md:space-y-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.slug}>
                <div
                  data-testid={`service-block-${s.slug}`}
                  className="group grid grid-cols-1 lg:grid-cols-12 gap-0 border border-border bg-surface overflow-hidden hover:border-brand/40 transition-colors duration-300"
                >
                  <div className={`lg:col-span-5 relative min-h-[280px] overflow-hidden ${reverse ? "lg:order-2" : ""}`}>
                    <img
                      src={s.image}
                      alt={s.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface/80 via-surface/20 to-transparent lg:bg-gradient-to-r" />
                  </div>
                  <div className={`lg:col-span-7 p-8 md:p-12 flex flex-col justify-center ${reverse ? "lg:order-1" : ""}`}>
                    <div className="flex items-center gap-4">
                      <Icon size={36} className="text-brand-light" strokeWidth={1.5} />
                      <span className="font-display font-black text-4xl text-border leading-none">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h2 className="mt-6 font-display font-bold text-3xl md:text-4xl text-white tracking-tight">{s.title}</h2>
                    <p className="mt-4 text-slatetxt text-lg leading-relaxed max-w-xl">{s.short}</p>
                    <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {s.points.map((p) => (
                        <li key={p} className="flex items-start gap-3 text-white/85">
                          <Check size={18} className="text-brand-light mt-1 shrink-0" />
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/quote"
                      data-testid={`service-quote-${s.slug}`}
                      className="mt-8 inline-flex items-center gap-2 text-white font-medium hover:text-brand-light transition-colors group/link w-fit"
                    >
                      Request a quote for this service
                      <ArrowUpRight size={18} className="transition-transform duration-300 group-hover/link:translate-x-1 group-hover/link:-translate-y-1" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
